import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BankStatus from "../../components/BankStatus";
import { FaArrowLeft, FaTimes, FaCheck } from "react-icons/fa";
import { logout, getCurrentUserId } from "../../utils/auth";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import { getSidebarMenus } from "../../constants/sidebarMenus";
import "../../css/User/Kyc.css";
import { useProfile } from "../../hook/useProfile";
import { walletApi } from "../../api/walletApi";
import TopHeader from "../../components/comman/TopHeader";
import Sidebar from "../../components/comman/Sidebar";
import Input from "../../components/comman/Input";

function Kyc3() {
  const currentUserId = getCurrentUserId();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { isProfileInfo, isLoading } = useProfile();
  const [showMsgDrawer, setShowMsgDrawer] = useState(false);
  const [activeTab, setActiveTab] = useState("forYou");
  const feedTYPE = window.location.pathname.includes("/feed/public")
    ? "public"
    : "prime";
  const [feedType, setFeedType] = useState(feedTYPE);
  const [showAccount, setShowAccount] = useState(false);
  const navigate = useNavigate();
  const [activeSidebar, setActiveSidebar] = useState("kyc");
  const [showSidebar, setShowSidebar] = useState(true);
  const sidebarMenus = getSidebarMenus(currentUserId);
  const bankKycStatus = isProfileInfo?.kycStatus?.toUpperCase();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showRejectedForm, setShowRejectedForm] = useState(false);

  // handle logout
  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  const [form, setForm] = useState({
    accountHolderName: "",
    accountNumber: "",
    confirmAccountNumber: "",
    ifscCode: "",
    branchName: "",
    upiId: "",
    panNumber: "",
  });

  const handleSubmit = async () => {
    if (!validate()) {
      toast.error("Please ensure all details are correct.");
      return;
    }

    setLoading(true);

    try {
      await walletApi.submitKyc(form);

            toast.success("KYC submitted successfully");

      setForm({
        accountHolderName: "",
        accountNumber: "",
        confirmAccountNumber: "",
        ifscCode: "",
        branchName: "",
        upiId: "",
        panNumber: "",
      });
      setErrors({});

      setTimeout(() => {
        navigate("/wallet");
      }, 1200);
    } catch (err) {
      const errorMsg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        "KYC submission failed";

      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    if (name === "accountHolderName") {
      updatedValue = value
        .replace(/[^a-zA-Z\s]/g, "")
        .replace(/\s{2,}/g, " ")
        .trimStart();
    }

    if (name === "accountNumber" || name === "confirmAccountNumber") {
      updatedValue = value.replace(/\D/g, "").slice(0, 18);
    }

    if (name === "ifscCode") {
      updatedValue = value
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "")
        .slice(0, 11);
    }

    if (name === "branchName") {
      updatedValue = value
        .replace(/[^a-zA-Z\s]/g, "")
        .replace(/\s{2,}/g, " ")
        .trimStart();
    }

    if (name === "panNumber") {
      updatedValue = value
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "")
        .slice(0, 10);
    }

    if (name === "upiId") {
      updatedValue = value
        .toLowerCase()
        .replace(/[^a-z0-9@._]/g, "")
        .replace(/\.{2,}/g, ".")
        .replace(/@{2,}/g, "@")
        .slice(0, 50);
    }

    setForm((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!form.accountHolderName || form.accountHolderName.length < 3) {
      newErrors.accountHolderName = "Enter valid account holder name";
    }

    if (!/^\d{9,18}$/.test(form.accountNumber)) {
      newErrors.accountNumber = "Enter valid account number (9-18 digits)";
    }

    if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(form.ifscCode)) {
      newErrors.ifscCode = "Invalid IFSC code";
    }

    if (!form.branchName || form.branchName.length < 3) {
      newErrors.branchName = "Enter valid branch name";
    }

    if (form.upiId && !/^[\w.-]+@[\w.-]+$/.test(form.upiId)) {
      newErrors.upiId = "Invalid UPI ID";
    }

    if (form.panNumber && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(form.panNumber)) {
      newErrors.panNumber = "Invalid PAN number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // if (isLoading) {
  //   return (
  //     <div className="d-flex align-items-center justify-content-center vh-100">
  //       <div className="spinner-border theme-color" role="status">
  //         <span className="visually-hidden">Loading...</span>
  //       </div>
  //     </div>
  //   );
  // }

  // useEffect(() => {
  //   if (
  //     bankKycStatus === "VERIFIED" ||
  //     bankKycStatus === "REQUESTED" ||
  //     bankKycStatus === "REJECTED"
  //   ) {
  //     setLoading(false);
  //   }
  //   if (bankKycStatus === "REJECTED") {
  //     setLoading(true);
  //   }
  // }, [bankKycStatus]);

  return (
    <div className="container-xxl p-0">
      <div className="feed-page-wrapper">
        <TopHeader
          onToggleSidebar={() => setShowSidebar((prev) => !prev)}
          onOpenMessages={() => setShowMsgDrawer(true)}
          creditAmount={50}
          notificationCount={5}
          messageCount={0}
        />
        <div className="prime-layout-container .container-fluid">
          <div className="row">
            {!showSidebar && (
              <div
                className="left-sidebar-overlay d-md-none"
                onClick={() => setShowSidebar(true)}
              />
            )}

            <Sidebar
              showSidebar={showSidebar}
              sidebarMenus={sidebarMenus}
              activeSidebar={activeSidebar}
              feedType={feedType}
              onNavigate={(item) => {
                setActiveSidebar(item.key);
                if (item.path) {
                  navigate(item.path);
                }
              }}
              onLogout={handleLogout}
            />

            <div className="col-lg-9 col-md-9 col-12 overflow-auto center-area-container">
              <div className="col-12 kyc_container">
                <div className="kyc-page">
                  <div className="kyc-card ">
                    {(bankKycStatus === "NONE" || !bankKycStatus) && (
                      <div className="kyc-form shadow">
                        <h3 className="theme-color">Bank Details</h3>
                        <Input
                          name="accountHolderName"
                          placeholder="Account Holder Name"
                          value={form.accountHolderName}
                          className="password-input"
                          onChange={handleChange}
                        />
                        {errors.accountHolderName && (
                          <p className="error">{errors.accountHolderName}</p>
                        )}

                        <Input
                          name="accountNumber"
                          placeholder="Account Number"
                          value={form.accountNumber}
                          className="password-input"
                          onChange={handleChange}
                          inputMode="numeric"
                          maxLength={18}
                        />
                        {errors.accountNumber && (
                          <p className="error">{errors.accountNumber}</p>
                        )}

                        <Input
                          name="ifscCode"
                          placeholder="IFSC Code"
                          value={form.ifscCode}
                          className="password-input"
                          onChange={handleChange}
                          maxLength={11}
                        />
                        {errors.ifscCode && (
                          <p className="error">{errors.ifscCode}</p>
                        )}

                        <Input
                          name="branchName"
                          placeholder="Branch Name"
                          value={form.branchName}
                          className="password-input"
                          onChange={handleChange}
                        />
                        {errors.branchName && (
                          <p className="error">{errors.branchName}</p>
                        )}

                        <Input
                          name="upiId"
                          placeholder="UPI ID (Optional)"
                          value={form.upiId}
                          className="password-input"
                          onChange={handleChange}
                        />
                        {errors.upiId && (
                          <p className="error">{errors.upiId}</p>
                        )}

                        <Input
                          name="panNumber"
                          placeholder="PAN (Optional)"
                          value={form.panNumber}
                          className="password-input"
                          onChange={handleChange}
                          maxLength={10}
                        />
                        {errors.panNumber && (
                          <p className="error">{errors.panNumber}</p>
                        )}

                        <div className="d-flex justify-content-center">
                          <button
                            type="button"
                            className="continue01-btn"
                            onClick={handleSubmit}
                            disabled={loading}
                          >
                            {loading ? "Submitting..." : "Submit"}
                          </button>
                        </div>
                      </div>
                    )}

                    {(bankKycStatus === "VERIFIED" ||
                      bankKycStatus === "REQUESTED") && (
                      <BankStatus
                        bankKycStatus={bankKycStatus}
                        onResubmit={() => setShowRejectedForm(true)}
                      />
                    )}

                    {bankKycStatus === "REJECTED" && !showRejectedForm && (
                      <BankStatus
                        bankKycStatus="REJECTED"
                        onResubmit={() => setShowRejectedForm(true)}
                      />
                    )}

                    {bankKycStatus === "REJECTED"  && showRejectedForm && (
                      <div className="kyc-form shadow">
                        <h3 className="theme-color">Re-submit Bank Details</h3>
                        <Input
                          name="accountHolderName"
                          placeholder="Account Holder Name"
                          value={form.accountHolderName}
                          className="password-input"
                          onChange={handleChange}
                        />
                        {errors.accountHolderName && (
                          <p className="error">{errors.accountHolderName}</p>
                        )}

                        <div style={{ position: "relative" }}>
                          <Input
                            type={showAccount ? "text" : "password"}
                            name="accountNumber"
                            placeholder="Account Number"
                            value={form.accountNumber}
                            className="password-input pe-5"
                            onChange={handleChange}
                            inputMode="numeric"
                            maxLength={18}
                          />

                          <span
                            onClick={() => setShowAccount(!showAccount)}
                            style={{
                              position: "absolute",
                              right: "12px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              fontSize: "18px",
                              color: "#666",
                            }}
                          >
                            {showAccount ? (
                              <i className="bi bi-eye-fill"></i>
                            ) : (
                              <i className="bi bi-eye-slash-fill"></i>
                            )}
                          </span>
                        </div>

                        {errors.accountNumber && (
                          <p className="error">{errors.accountNumber}</p>
                        )}
                        <div
                          style={{
                            position: "relative",
                            marginTop: "10px",
                          }}
                        >
                          <Input
                            type="password"
                            name="confirmAccountNumber"
                            placeholder="Confirm Account Number"
                            value={form.confirmAccountNumber || ""}
                            className="password-input pe-5"
                            onChange={handleChange}
                            inputMode="numeric"
                            maxLength={18}
                          />

                          {/* Match Icon */}
                          {form.confirmAccountNumber && (
                            <span
                              style={{
                                position: "absolute",
                                right: "12px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                fontSize: "18px",
                                pointerEvents: "none",
                              }}
                            >
                              {form.confirmAccountNumber ===
                              form.accountNumber ? (
                                <i className="bi bi-check-circle-fill text-success"></i>
                              ) : (
                                <i className="bi bi-x-circle-fill text-danger"></i>
                              )}
                            </span>
                          )}
                        </div>
                        {form.confirmAccountNumber &&
                          form.confirmAccountNumber !== form.accountNumber && (
                            <p className="error">
                              Account numbers do not match
                            </p>
                          )}
                        <Input
                          name="ifscCode"
                          placeholder="IFSC Code"
                          value={form.ifscCode}
                          className="password-input"
                          onChange={handleChange}
                        />
                        {errors.ifscCode && (
                          <p className="error">{errors.ifscCode}</p>
                        )}

                        <Input
                          name="branchName"
                          placeholder="Branch Name"
                          value={form.branchName}
                          className="password-input"
                          onChange={handleChange}
                        />
                        {errors.branchName && (
                          <p className="error">{errors.branchName}</p>
                        )}

                        <Input
                          name="upiId"
                          placeholder="UPI ID (Optional)"
                          value={form.upiId}
                          className="password-input"
                          onChange={handleChange}
                        />
                        {errors.upiId && (
                          <p className="error">{errors.upiId}</p>
                        )}

                        <Input
                          name="panNumber"
                          placeholder="PAN (Optional)"
                          value={form.panNumber}
                          className="password-input"
                          onChange={handleChange}
                        />
                        {errors.panNumber && (
                          <p className="error">{errors.panNumber}</p>
                        )}

                        <div className="d-flex justify-content-center">
                          <button
                            type="button"
                            className="continue01-btn"
                            onClick={handleSubmit}
                            disabled={loading}
                          >
                            {loading ? "Submitting..." : "Submit"}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Kyc3;
